/* @flow */
import * as React from 'react';
import classNames from 'classnames';

import ActionButton from '../ActionButton';

import styles from './styles.module.scss';

type Props = {
  text?: string,
  isError?: boolean,
  isSticky?: boolean,
  visible?: boolean,
  onHide: () => any,
};

class Snackbar extends React.PureComponent<Props, void> {
  componentDidMount() {
    if (this.props.visible && !this.props.isSticky) {
      setTimeout(this.props.onHide, 4000);
    }
  }

  componentDidUpdate(prevProps: Props) {
    if (!prevProps.visible && this.props.visible && !this.props.isSticky) {
      setTimeout(this.props.onHide, 4000);
    }
  }

  render() {
    const { visible, isError, text, isSticky } = this.props;
    const classNameArray = [];
    if (visible) {
      classNameArray.push(styles.snackbarVisible);
      if (isError) {
        classNameArray.push(styles.snackbarError);
      }
      if (isSticky) {
        classNameArray.push(styles.snackbarSticky);
      }
    } else {
      classNameArray.push(styles.snackbarHidden);
    }
    return (
      <div className={classNames(...classNameArray)}>
        {text}
        {!!isSticky && <ActionButton iconName={'close'} onClick={this.props.onHide} />}
      </div>
    );
  }
}

export default Snackbar;
